import { subMonths } from 'date-fns';

import * as R from 'ramda';

import { PaperWithList } from 'components';

import { useUserContext } from 'App/context';

import { HighlightedColor, Categories } from 'App/types';

import { RoutePaths } from 'impactApp/routes/routePaths';

import { t as translation } from 'i18next';

import { convertGramsToLargerUnits, formatFullDate, formatMonthAndYear, formatNumber, formatCurrency } from 'App/utils';

import { CurrencySymbol } from 'App/translations';

import { useHighestTransactionsListData } from 'impactApp/modules/HomePage';

import { CURRENT_DATE } from 'App/components';

import { useTranslation } from 'react-i18next';

import i18next from 'i18next';

import { Transaction } from '@ecolytiq/js-data-provider';

import { TransactionListItem } from './TransactionListItem';

const TRANSACTIONS_TO_DISPLAY = 3;

const generateItems = (transactions: Transaction[], locale: string) => {
  return transactions.map((transaction: Transaction, index) => {
    const {
      date,
      merchant,
      co2Footprint: { value: co2Value },
      id: transactionId,
      amount: { value, currencyCode },
      metaCategory,
    } = transaction;
    const formatDate = formatFullDate(date, locale);
    const formatCO2ToKg = convertGramsToLargerUnits(co2Value);
    const amountValue = formatCurrency(value, currencyCode as CurrencySymbol);
    const redirectUrl = `${RoutePaths.TRANSACTIONS}/${transactionId}`;
    const footprint = `${formatNumber(+formatCO2ToKg[0])} ${i18next.t(formatCO2ToKg[1])}`;
    return (
      <TransactionListItem
        redirectURL={redirectUrl}
        key={transactionId}
        category={metaCategory as Categories}
        date={formatDate}
        description={merchant?.name || translation('common:merchantPlaceholder')}
        footprint={footprint}
        id={transactionId}
        value={amountValue}
        transaction={transaction}
        removeLastDivider={index !== transactions.length - 1}
      />
    );
  });
};

export const TransactionList = () => {
  const { ORANGE } = HighlightedColor;

  const { i18n, t } = useTranslation();

  const [{ monthDelta }] = useUserContext();

  const currentDate = subMonths(CURRENT_DATE, monthDelta);

  const { transactions, isLoading } = useHighestTransactionsListData({
    month: currentDate.getMonth() + 1,
    year: currentDate.getFullYear(),
  });

  const date = currentDate.toISOString();

  const subtitle = `${i18n.language === 'en' ? t('common:inPreposition') : ''} ${formatMonthAndYear(date)}`;

  return (
    <PaperWithList
      appearance={ORANGE}
      isLoading={isLoading}
      list={generateItems(R.take(TRANSACTIONS_TO_DISPLAY, transactions), i18n.language)}
      subtitle={subtitle}
      title={t('homePage:transactionFootprint:title')}
    />
  );
};
